<wbo-switch-edit-control [readonly]="isReadonly" [label]="label" [elementId]="elementId" [(ngModel)]="value">
</wbo-switch-edit-control>
